<template>
  <header class="mr-8 md min-w-0" :class="$mq">
    <div>
      <div class="flex space-x-8">
        <h1
          class="text-xl md:text-3xl md:truncate my-0"
          :class="!textSearch ? 'font-bold uppercase' : 'font-normal'"
        >
          <template v-if="textSearch">
            Showing results for: <strong>{{ textSearch }}</strong>
          </template>
          <template v-else>{{ title }}</template>
        </h1>
      </div>
      <div>
        <div
          class="text-sm md:text-base text-grey-darker mt-2"
          :class="{
            invisible: loading || !countersVisible(),
            hidden: !term || countersHidden,
          }"
        >
          {{ countText }} | {{ partialText }}
        </div>
      </div>
    </div>

    <h5 class="xs:hidden sm:flex mt-2 text-md opacity-50" v-if="subtitle">
      {{ subtitle }}
    </h5>
    <div class="mt-2 text-base hidden sm:block" v-if="autoSuggest">
      <p>
        No matching results for: <em>{{ term }}</em>
      </p>
    </div>
  </header>
</template>

<script>
import isSearchPage from "@/lib/isSearchPage"
import { mapState } from "vuex"
import * as PathHelpers from "@/lib/Listing/PathHelpers"

export default {
  name: "HeaderTitle",
  props: ["longtail", "competition", "meta"],
  methods: {
    isSearchPage,
    countersVisible() {
      return (this.exactMatches > 0 || this.partialCount > 0) && this.isSearchPage()
    },
  },
  computed: {
    exactMatches() {
      return this.listingsCount - this.partialCount
    },
    countText() {
      return this.exactMatches <= 0 ? "No close match" : `${this.exactMatches} close matches`
    },
    partialText() {
      return `${this.partialCount > 1000 ? "1000+" : this.partialCount} partial matches`
    },
    countersHidden() {
      return !this.autoSuggest && !this.countersVisible() && this.subtitle
    },
    title() {
      let title

      if (PathHelpers.trendingArtPath()) return "Trending Art"

      switch (this.sort) {
        case "newest":
          title = "All"
          break
        case "popular":
          title = "Popular"
          break
        default:
          title = "All"
      }

      if (this.longtail.headline) {
        title = this.longtail.headline
      } else if (this.competition.categoryTitle) {
        title = `${this.competition.categoryTitle} Finalists`
      } else if (this.competition.name) {
        title = this.competition.name
      } else {
        if (this.longtail.keyword) {
          title = title + " " + this.longtail.keyword
        }
        title = title + " Art"
      }

      if (window.location.search.includes("title=")) {
        title = new URLSearchParams(window.location.search).get("title")
        return title
      }

      if (this.meta) title = this.meta.header
      if (this.featured) title = "staff picks"
      if (this.exclusive) title = "new exclusives"
      if (this.boosted) title = "Featured Art"

      return title
    },
    subtitle() {
      if (this.exclusive) return "New artworks exclusive to Bluethumb"
      return this.longtail.content || (this.meta && this.meta.subheader)
    },
    textSearch() {
      return this.autoSuggest?.str || this.term
    },
    ...mapState("filter", {
      term: ({ filters }) => filters.term,
      autoSuggest: ({ autoSuggest }) => autoSuggest,
      sort: (state) => state.filters.sort,
      partialCount: (state) => state.partial_count,
      listingsCount: (state) => state.listings_count,
      loading: (state) => state.loading,
      featured: (state) => state.filters.featured,
      exclusive: (state) => state.filters.exclusive,
      boosted: (state) => state.filters.boosted,
    }),
  },
}
</script>
